module.exports = __webpack_public_path__ + "static/media/landing.6351953e.png";